<template>
  <div
    class="modal fade"
    id="resellerInfoMModal"
    tabindex="-1"
    aria-labelledby="resellerInfoMLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-xl modal-dialog-centered" style="max-width: 700px;">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title fw-bold">리셀러 정보 수정</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body" style="overflow-y: auto; max-height: 80vh;">
          <div class="modalInputDiv">
            <label>사업자등록번호<span class="text-danger">*</span></label>
            <input
              type="text"
              placeholder="사업자등록번호를 입력해주세요"
              v-model="businessNumber"
              @input="changeBusinessNumber"
              maxlength="12"
            />
            <div class="modalInputRight">
              <button
                type="button"
                class="btn btn-primary modalBtnRight"
                @click="businessNumberValidate"
              >
                중복확인
              </button>
            </div>
          </div>
          <div class="modalInputDiv">
            <label></label>
            <span class="businessNumberMsgM"></span>
          </div>
          <div class="modalInputDiv">
            <label>사업자등록증</label>
            <input
              type="text"
              :value="businessFileName"
              readonly
            />
            <input
              type="file"
              id="businessFileInputM"
              ref="businessFileInputM"
              @change="changeBusinessNumImage"
              style="display: none"
              accept=".png, .jpg, .jpeg, .pdf"
            />
            <div class="modalInputRight">
              <button
                type="button"
                class="btn btn-outline-dark modalBtnRight"
                @click="openBusinessFileInput"
              >
                <i class="material-icons" style="vertical-align: middle">attach_file</i>
              </button>
              <button
                type="button"
                class="btn btn-outline-dark modalBtnRight"
                v-if="businessFileName"
                @click="downloadBusinessNumImage"
              >
                <i class="material-icons" style="vertical-align: middle">download</i>
              </button>
              <button
                type="button"
                class="btn btn-outline-danger modalBtnRight"
                v-if="businessFileName"
                @click="deleteBusinessNumImage"
              >
                <i class="material-icons" style="vertical-align: middle">delete</i>
              </button>
            </div>
          </div>
          <div class="modalInputDiv">
            <label>테스트 여부</label>
            <a-checkbox v-model:checked="isTestCompany">테스트 리셀러로 등록</a-checkbox>
          </div>
          <div class="modalInputDiv">
            <label>리셀러명<span class="text-danger">*</span></label>
            <input
              type="text"
              placeholder="리셀러명을 입력해주세요"
              v-model="resellerName"
            />
          </div>
          <div class="modalInputDiv">
            <label>대표자명</label>
            <input
              type="text"
              placeholder="대표자명을 입력해주세요"
              v-model="ceoName"
            />
          </div>
          <div class="modalInputDiv">
            <label>대표 전화번호</label>
            <input
              type="text"
              placeholder="대표 전화번호를 입력해주세요"
              v-model="phoneNumber"
              @input="changePhoneNumber"
              maxlength="13"
            />
          </div>
          <div class="modalInputDiv">
            <label>페이지 로고</label>
            <input
              type="text"
              :value="logoFileName"
              readonly
            />
            <input
              type="file"
              id="logoFileInputM"
              ref="logoFileInputM"
              @change="changeLogoImage"
              style="display: none"
              accept="image/png, image/jpeg, image/jpg"
            />
            <div class="modalInputRight">
              <button
                type="button"
                class="btn btn-outline-dark modalBtnRight"
                @click="openLogoFileInput"
              >
                <i class="material-icons" style="vertical-align: middle">attach_file</i>
              </button>
              <button
                type="button"
                class="btn btn-outline-dark modalBtnRight"
                v-if="logoFileName"
                @click="downloadLogoImage"
              >
                <i class="material-icons" style="vertical-align: middle">download</i>
              </button>
              <button
                type="button"
                class="btn btn-outline-danger modalBtnRight"
                v-if="logoFileName"
                @click="deleteLogoImage"
              >
                <i class="material-icons" style="vertical-align: middle">delete</i>
              </button>
            </div>
          </div>
          <div class="modalInputDiv" v-if="logoPreviewUrl">
            <label></label>
            <img id="logoPrevM" class="imgPrev" :src="logoPreviewUrl" alt="" />
          </div>

          <hr style="margin: 1.5rem 0;" />

          <template v-if="accountId">
          <div class="modalInputDiv">
            <label>관리자 이름<span class="text-danger">*</span></label>
            <input
              type="text"
              placeholder="관리자 이름을 입력해주세요"
              v-model="managerName"
            />
          </div>
          <div class="modalInputDiv">
            <label>관리자 직급</label>
            <input
              type="text"
              placeholder="관리자 직급을 입력해주세요"
              v-model="managerDuty"
            />
          </div>
          <div class="modalInputDiv">
            <label>관리자 연락처</label>
            <input
              type="text"
              placeholder="관리자 연락처를 입력해주세요"
              v-model="managerPhoneNumber"
              @input="changeManagerPhoneNumber"
              maxlength="13"
            />
          </div>
          <div class="modalInputDiv">
            <label>관리자 아이디</label>
            <input
              type="text"
              :value="managerId"
              disabled
            />
          </div>
          </template>

          <hr v-if="accountId" style="margin: 1.5rem 0;" />

          <!-- 관리자 계정 변경 섹션 -->
          <div class="account-change-section">
            <h6 style="margin-bottom: 16px; font-weight: 600;">관리자 계정 변경</h6>
            <div class="modalInputDiv" v-if="isDetailLoaded && !accountId">
              <span class="verifyMsg fail" style="margin-left: 0;">등록된 관리자 계정이 없습니다.</span>
            </div>
            <template v-else-if="accountId">
            <div class="modalInputDiv">
              <label>사업자등록번호 확인<span class="text-danger">*</span></label>
              <input
                type="text"
                placeholder="사업자등록번호를 입력해주세요"
                v-model="verifyBusinessNumber"
                @input="changeVerifyBusinessNumber"
                maxlength="12"
                :disabled="isAccountVerified"
              />
              <div class="modalInputRight">
                <button
                  type="button"
                  class="btn btn-primary modalBtnRight"
                  @click="verifyAccount"
                  :disabled="isAccountVerified"
                >
                  {{ isAccountVerified ? '인증완료' : '인증' }}
                </button>
              </div>
            </div>
            <div class="modalInputDiv" v-if="verifyMessage">
              <label></label>
              <span :class="['verifyMsg', isAccountVerified ? 'success' : 'fail']">{{ verifyMessage }}</span>
            </div>

            <template v-if="isAccountVerified">
              <div class="modalInputDiv">
                <label>새 관리자 아이디</label>
                <input
                  type="text"
                  placeholder="새 관리자 아이디를 입력해주세요"
                  v-model="newManagerId"
                  @input="changeNewManagerId"
                />
                <div class="modalInputRight">
                  <button
                    type="button"
                    class="btn btn-primary modalBtnRight"
                    @click="checkManagerIdDuplicate"
                    :disabled="!newManagerId.trim()"
                  >
                    중복확인
                  </button>
                </div>
              </div>
              <div class="modalInputDiv" v-if="managerIdCheckMessage">
                <label></label>
                <span :class="['verifyMsg', isManagerIdValid ? 'success' : 'fail']">{{ managerIdCheckMessage }}</span>
              </div>
              <div class="modalInputDiv">
                <label>새 비밀번호</label>
                <input
                  type="password"
                  placeholder="새 비밀번호를 입력해주세요"
                  v-model="newPassword"
                />
              </div>
              <div class="modalInputDiv">
                <label>비밀번호 확인</label>
                <input
                  type="password"
                  placeholder="비밀번호를 다시 입력해주세요"
                  v-model="confirmPassword"
                />
              </div>
              <div class="modalInputDiv" v-if="newPassword && confirmPassword && newPassword !== confirmPassword">
                <label></label>
                <span class="verifyMsg fail">비밀번호가 일치하지 않습니다.</span>
              </div>
            </template>
            </template>
          </div>
        </div>
        <!-- 리셀러 콘솔 지원 접속(운영자만·동의 없음 — 사용자 결정 10-29). 공용 비밀번호 대신 이 길로 -->
        <div v-if="resellerId" class="px-4">
          <support-access-card :company-id="resellerId" company-type="RESELLER" :company-name="resellerName" />
        </div>
        <div class="modal-footer" style="justify-content: center">
          <button
            type="button"
            class="btn btn-secondary"
            data-bs-dismiss="modal"
            style="color: #666666; background: #fff; border: 1px solid #666;"
          >
            취소
          </button>
          <button
            type="button"
            class="btn btn-info"
            @click="modifyReseller()"
            :disabled="isSubmitting"
          >
            수정하기
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// css-install.js 와 동일한 모듈 인스턴스를 써야 data-api 로 생성된 모달 인스턴스를 찾을 수 있음 (esm 빌드 사용 금지)
import bootstrapJs from "bootstrap/dist/js/bootstrap";
import { openDialog, decodeUtfText, changeBytesToKilos, businessNumberFormatter, phoneNumberFormatter } from "@/utils/utils";
import { YnEnum } from '@/enums/common.enums';
import SupportAccessCard from "@/views/components/SupportAccessCard.vue";

export default {
  name: "ResellerInfoM",
  components: { SupportAccessCard },
  data() {
    return {
      type: "RESELLER",
      resellerId: "",

      resellerName: "",
      ceoName: "",
      phoneNumber: "",
      businessNumber: "",
      originalBusinessNumber: "",

      managerName: "",
      managerDuty: "",
      managerPhoneNumber: "",
      managerId: "",

      businessFileName: "",
      businessFileData: null,
      businessImgUrl: "",

      logoFileName: "",
      logoFileData: null,
      logoImgUrl: "",
      logoPreviewUrl: "",

      isDetailLoaded: false,
      isSubmitting: false,

      isBusinessNumberValid: true,
      isTestCompany: false,

      // 관리자 계정 변경 관련
      verifyBusinessNumber: "",
      isAccountVerified: false,
      verifyMessage: "",
      newManagerId: "",
      newPassword: "",
      confirmPassword: "",
      isManagerIdValid: false,
      managerIdCheckMessage: "",
      accountId: "", // 관리자 계정 ID
    };
  },
  props: {
    data: {
      type: Object,
      required: false,
      default: () => ({})
    }
  },
  mounted() {
    this.$el.addEventListener("hidden.bs.modal", this.resetOnHidden);
  },
  beforeUnmount() {
    this.$el.removeEventListener("hidden.bs.modal", this.resetOnHidden);
  },
  watch: {
    data: {
      immediate: true,
      deep: true,
      handler(newValue) {
        if (newValue && newValue.resellerId !== this.resellerId) {
          this.initValues();

          if (newValue.cNo) {
            this.businessNumber = newValue.cNo;
            this.originalBusinessNumber = newValue.cNo;
          }
          if (newValue.isTestCompany !== undefined) {
            this.isTestCompany = newValue.isTestCompany;
          }
          if (newValue.cNoUrl) {
            this.businessImgUrl = newValue.cNoUrl;
            const businessUrlArray = newValue.cNoUrl.split("/");
            this.businessFileName = decodeUtfText(businessUrlArray[businessUrlArray.length - 1]);
          }
          this.changeBusinessNumber();
          this.isBusinessNumberValid = true;

          if (newValue.call) {
            this.phoneNumber = newValue.call;
            this.changePhoneNumber();
          }
          if (newValue.ceo) this.ceoName = newValue.ceo;
          if (newValue.imgUrl) {
            this.logoImgUrl = newValue.imgUrl;
            this.logoPreviewUrl = newValue.imgUrl;
            const logoUrlArray = newValue.imgUrl.split("/");
            this.logoFileName = decodeUtfText(logoUrlArray[logoUrlArray.length - 1]);
          }
          if (newValue.resellerId) this.resellerId = newValue.resellerId;
          if (newValue.name) this.resellerName = newValue.name;

          if (newValue.accountInfo) {
            if (newValue.accountInfo.mobile) {
              this.managerPhoneNumber = newValue.accountInfo.mobile;
              this.changeManagerPhoneNumber();
            }
            if (newValue.accountInfo.name) this.managerName = newValue.accountInfo.name;
            if (newValue.accountInfo.duty) this.managerDuty = newValue.accountInfo.duty;
            if (newValue.accountInfo.username) this.managerId = newValue.accountInfo.username;
            if (newValue.accountInfo._id) this.accountId = newValue.accountInfo._id;
          }
          this.isDetailLoaded = !!newValue.resellerId;
        }
      },
    },
  },
  methods: {
    changePhoneNumber() {
      this.phoneNumber = phoneNumberFormatter(this.phoneNumber.toString());
    },
    changeManagerPhoneNumber() {
      this.managerPhoneNumber = phoneNumberFormatter(this.managerPhoneNumber.toString());
    },
    changeBusinessNumber() {
      this.businessNumber = businessNumberFormatter(this.businessNumber.toString());
    },

    changeVerifyBusinessNumber() {
      this.verifyBusinessNumber = businessNumberFormatter(this.verifyBusinessNumber.toString());
    },

    // 사업자등록번호로 계정 변경 권한 인증
    verifyAccount() {
      const trimmedVerifyNumber = this.verifyBusinessNumber.replace(/-/g, '');
      const trimmedOriginalNumber = this.originalBusinessNumber.replace(/-/g, '');

      if (trimmedVerifyNumber === trimmedOriginalNumber) {
        this.isAccountVerified = true;
        this.verifyMessage = "인증되었습니다. 아이디/비밀번호를 변경할 수 있습니다.";
      } else {
        this.isAccountVerified = false;
        this.verifyMessage = "사업자등록번호가 일치하지 않습니다.";
      }
    },

    // 새 아이디 입력이 바뀌면 이전 중복확인 결과 무효화
    changeNewManagerId() {
      this.isManagerIdValid = false;
      this.managerIdCheckMessage = "";
    },

    // 서버 오류 사유 추출
    getErrorMessage(error, fallback) {
      const message = error && error.response && error.response.data && error.response.data.message;
      if (Array.isArray(message)) return message.join(", ");
      return message || fallback;
    },

    // 관리자 아이디 중복 확인
    async checkManagerIdDuplicate() {
      const newId = this.newManagerId.trim();
      if (!newId) {
        this.managerIdCheckMessage = "아이디를 입력해주세요.";
        this.isManagerIdValid = false;
        return;
      }

      // 현재 아이디와 동일한 경우
      if (newId === this.managerId) {
        this.managerIdCheckMessage = "현재 사용 중인 아이디입니다.";
        this.isManagerIdValid = true;
        return;
      }

      try {
        const response = await this.$apiInstance.get(`/accounts/duplicateCheck/${encodeURIComponent(newId)}`);
        // 응답을 기다리는 사이 입력이 바뀌었으면 이전 결과는 무시
        if (newId !== this.newManagerId.trim()) return;
        if (response && (response.status === 200 || response.status === 201) && !response.data) {
          this.managerIdCheckMessage = "사용할 수 있는 아이디입니다.";
          this.isManagerIdValid = true;
        } else {
          this.managerIdCheckMessage = "이미 존재하는 아이디입니다.";
          this.isManagerIdValid = false;
        }
      } catch (error) {
        if (newId !== this.newManagerId.trim()) return;
        this.managerIdCheckMessage = this.getErrorMessage(error, "중복 확인 중 오류가 발생했습니다.");
        this.isManagerIdValid = false;
      }
    },

    async modifyReseller() {
      if (this.isSubmitting) return;
      this.isSubmitting = true;
      try {
        await this.submitModify();
      } finally {
        this.isSubmitting = false;
      }
    },

    async submitModify() {
      if (!(await this.validateData())) return;

      let accountUpdateMessage = "";
      let accountUpdateFailed = false;
      let accountUpdateError = "";

      // try/catch 는 API 호출 구간에만 적용 (성공 이후 UI 처리 오류가 "수정 실패"로 표시되지 않도록)
      try {
        const obj = {};

        obj.name = this.resellerName;
        obj.ceo = this.ceoName || '';
        obj.cNo = this.businessNumber.replace(/-/g, '');

        if (this.businessFileData) {
          const businessImgUrl = await this.uploadImageOnObjectStorage(this.businessFileData);
          obj.cNoUrl = businessImgUrl;
        } else if (this.businessImgUrl) {
          obj.cNoUrl = this.businessImgUrl;
        } else {
          obj.cNoUrl = '';
        }

        if (this.logoFileData) {
          const logoImgUrl = await this.uploadImageOnObjectStorage(this.logoFileData);
          obj.imgUrl = logoImgUrl;
        } else {
          obj.imgUrl = this.logoImgUrl;
        }

        obj.isTestCompany = this.isTestCompany ? YnEnum.Y : YnEnum.N;
        obj.call = this.phoneNumber ? this.phoneNumber.replace(/-/g, '') : '';
        obj.type = this.type;

        const accountInfo = {};
        accountInfo.username = this.managerId;
        accountInfo.role = this.type;
        accountInfo.name = this.managerName;
        accountInfo.duty = this.managerDuty || '';
        accountInfo.mobile = this.managerPhoneNumber ? this.managerPhoneNumber.replace(/-/g, '') : '';

        obj.accountInfo = accountInfo;

        const response = await this.$apiInstance.put(`/companies/${this.resellerId}`, obj);
        if (response.status !== 200 && response.status !== 201) {
          await openDialog("리셀러 정보 수정에 실패하였습니다.", "error", "확인");
          return;
        }

        // 업로드가 끝난 파일은 다음 저장 때 다시 올라가지 않도록 비움
        this.businessFileData = null;
        this.logoFileData = null;

        // 계정 변경이 인증된 경우 계정 정보 업데이트
        if (this.accountId && this.isAccountVerified && (this.newManagerId.trim() || this.newPassword)) {
          try {
            const result = await this.updateAccountInfo();
            if (result.usernameChanged && result.passwordChanged) {
              accountUpdateMessage = " 관리자 아이디와 비밀번호가 변경되었습니다.";
            } else if (result.usernameChanged) {
              accountUpdateMessage = " 관리자 아이디가 변경되었습니다.";
            } else if (result.passwordChanged) {
              accountUpdateMessage = " 비밀번호가 변경되었습니다.";
            }
          } catch (accountError) {
            console.log(accountError);
            accountUpdateFailed = true;
            accountUpdateError = this.getErrorMessage(accountError, "");
          }
        }
      } catch (error) {
        console.log(error);
        await openDialog("리셀러 정보 수정에 실패하였습니다.", "error", "확인");
        return;
      }

      // 여기부터는 수정 성공 이후 처리 (실패 팝업을 띄우지 않음)
      if (accountUpdateFailed) {
        await openDialog(
          "리셀러 정보는 수정되었으나, 계정 정보 변경에 실패했습니다." + (accountUpdateError ? ` (${accountUpdateError})` : ""),
          "warning",
          "확인"
        );
      } else {
        await openDialog("리셀러 정보 수정이 완료되었습니다." + accountUpdateMessage, "success", "확인");
      }
      this.resetAccountChange(!accountUpdateFailed);
      this.$emit('reload');
      this.closeModal();
    },

    // 모달이 닫히면 입력/인증/파일 상태를 모두 초기화.
    // resellerId 도 비워 두어, 같은 리셀러를 다시 열어도 부모가 새로 내려주는 상세 데이터로 watcher 가 다시 채우도록 함
    resetOnHidden() {
      if (this.$refs.businessFileInputM) this.$refs.businessFileInputM.value = "";
      if (this.$refs.logoFileInputM) this.$refs.logoFileInputM.value = "";
      this.initValues();
      this.businessFileName = "";
      this.logoFileName = "";
      this.resellerId = "";
      const msg = document.querySelector(".businessNumberMsgM");
      if (msg) {
        msg.setAttribute("class", "businessNumberMsgM");
        msg.textContent = "";
      }
      this.isBusinessNumberValid = true;
    },

    closeModal() {
      const modal = document.getElementById('resellerInfoMModal');
      if (modal) {
        bootstrapJs.Modal.getOrCreateInstance(modal).hide();
      }
    },

    // 관리자 계정 변경 영역 초기화 (같은 리셀러를 다시 열 때 이전 입력이 남지 않도록)
    resetAccountChange(applied) {
      if (applied && this.isAccountVerified && this.newManagerId.trim() && this.newManagerId.trim() !== this.managerId) {
        this.managerId = this.newManagerId.trim();
      }
      this.verifyBusinessNumber = "";
      this.isAccountVerified = false;
      this.verifyMessage = "";
      this.newManagerId = "";
      this.newPassword = "";
      this.confirmPassword = "";
      this.isManagerIdValid = false;
      this.managerIdCheckMessage = "";
    },

    // 계정 정보 업데이트 (아이디/비밀번호) - PUT /accounts/username/:accountId
    async updateAccountInfo() {
      const newUsername = this.newManagerId.trim() || this.managerId;
      const usernameChanged = newUsername !== this.managerId;
      const passwordChanged = !!this.newPassword;

      if (!usernameChanged && !passwordChanged) {
        return { usernameChanged, passwordChanged };
      }

      const requestBody = { newUsername };
      if (passwordChanged) {
        requestBody.newPassword = this.newPassword;
      }

      const response = await this.$apiInstance.put(`/accounts/username/${this.accountId}`, requestBody);
      if (response.status !== 200 && response.status !== 201) {
        throw new Error("계정 정보 변경 실패");
      }
      return { usernameChanged, passwordChanged };
    },

    async uploadImageOnObjectStorage(fileData) {
      const response = await this.$apiInstance.post(`/object-storages`, fileData);
      if (response.status === 200 || response.status === 201) {
        return response.data.url;
      } else {
        return "";
      }
    },

    async businessNumberValidate() {
      const trimmedBusinessNumber = this.businessNumber.replace(/-/g, '');
      const businessNumberMsg = document.querySelector(".businessNumberMsgM");
      if (this.businessNumber.replaceAll('-', '').length < 10) {
        businessNumberMsg.setAttribute("class", "businessNumberMsgM fail");
        businessNumberMsg.textContent = "잘못된 사업자등록번호입니다.";
        this.isBusinessNumberValid = false;
      } else {
        try {
          const response = await this.$apiInstance.get(`/companies/duplicateCheck/cNo/${trimmedBusinessNumber}`);
          if (response && (response.status === 200 || response.status === 201) && !response.data) {
            businessNumberMsg.setAttribute("class", "businessNumberMsgM success");
            businessNumberMsg.textContent = "사용할 수 있는 사업자등록번호입니다.";
            this.isBusinessNumberValid = true;
          } else if (this.originalBusinessNumber.replace(/-/g, '') === trimmedBusinessNumber) {
            businessNumberMsg.setAttribute("class", "businessNumberMsgM success");
            businessNumberMsg.textContent = "사용할 수 있는 사업자등록번호입니다.";
            this.isBusinessNumberValid = true;
          } else {
            businessNumberMsg.setAttribute("class", "businessNumberMsgM fail");
            businessNumberMsg.textContent = "이미 존재하는 사업자등록번호입니다.";
            this.isBusinessNumberValid = false;
          }
        } catch (error) {
          console.log(error);
          businessNumberMsg.setAttribute("class", "businessNumberMsgM fail");
          businessNumberMsg.textContent = this.getErrorMessage(error, "중복 확인 중 오류가 발생했습니다.");
          this.isBusinessNumberValid = false;
        }
      }
    },

    openBusinessFileInput() {
      this.$refs.businessFileInputM.click();
    },

    openLogoFileInput() {
      this.$refs.logoFileInputM.click();
    },

    validateFile(file) {
      let result = true;
      if (
        file.type !== 'image/png' &&
        file.type !== 'image/jpeg' &&
        file.type !== 'image/jpg'
      ) {
        alert('png, jpeg, jpg 파일만 첨부 가능합니다.');
        result = false;
      } else if (changeBytesToKilos(file.size) > 100) {
        alert('파일 크기가 100MB를 초과합니다.');
        result = false;
      }
      return result;
    },

    validateFileSize(file) {
      let result = true;
      if (changeBytesToKilos(file.size) > 100) {
        alert('파일 크기가 100MB를 초과합니다.');
        result = false;
      }
      return result;
    },

    changeBusinessNumImage() {
      const fileInput = document.getElementById("businessFileInputM");
      if (fileInput.files && fileInput.files[0]) {
        const validateFileSize = this.validateFileSize(fileInput.files[0]);
        if (validateFileSize) {
          this.businessFileName = fileInput.files[0].name;
          const formData = new FormData();
          formData.append("file", fileInput.files[0]);
          this.businessFileData = formData;
        }
      }
    },

    deleteBusinessNumImage() {
      this.businessFileData = null;
      this.businessFileName = '';
      this.businessImgUrl = '';
    },

    changeLogoImage() {
      const fileInput = document.getElementById("logoFileInputM");
      if (fileInput.files && fileInput.files[0]) {
        const validateFile = this.validateFile(fileInput.files[0]);
        if (validateFile) {
          const reader = new FileReader();
          reader.onload = (e) => {
            this.logoPreviewUrl = e.target.result;
          };
          reader.readAsDataURL(fileInput.files[0]);
          this.logoFileName = fileInput.files[0].name;

          const formData = new FormData();
          formData.append("file", fileInput.files[0]);
          this.logoFileData = formData;
        }
      }
    },

    downloadBusinessNumImage() {
      const fileInput = this.$refs.businessFileInputM;
      const file = fileInput.files[0];
      if (file) {
        const downloadLink = document.createElement("a");
        downloadLink.href = URL.createObjectURL(file);
        downloadLink.download = file.name;
        downloadLink.click();
      } else {
        const downloadLink = document.createElement("a");
        downloadLink.target = "_blank";
        downloadLink.href = this.businessImgUrl;
        downloadLink.download = this.businessFileName;
        downloadLink.click();
      }
    },

    deleteLogoImage() {
      this.logoFileData = null;
      this.logoFileName = '';
      this.logoImgUrl = '';
      this.logoPreviewUrl = '';
      this.$refs.logoFileInputM.value = '';
    },

    downloadLogoImage() {
      const fileInput = this.$refs.logoFileInputM;
      const file = fileInput.files[0];
      if (file) {
        const downloadLink = document.createElement("a");
        downloadLink.href = URL.createObjectURL(file);
        downloadLink.download = file.name;
        downloadLink.click();
      } else {
        const downloadLink = document.createElement("a");
        downloadLink.target = "_blank";
        downloadLink.href = this.logoImgUrl;
        downloadLink.download = this.logoFileName;
        downloadLink.click();
      }
    },

    async validateData() {
      let result = true;
      if (!this.resellerName) {
        await openDialog("리셀러명을 입력해 주세요.", "error", "확인");
        result = false;
      } else if (!this.businessNumber) {
        await openDialog("사업자등록번호를 입력해 주세요.", "error", "확인");
        result = false;
      } else if (this.businessNumber.replaceAll('-', '').length < 10) {
        await openDialog("사업자등록번호를 올바르게 입력해 주세요.", "error", "확인");
        result = false;
      } else if (!this.isBusinessNumberValid) {
        await openDialog("사업자등록번호 중복확인을 해 주세요.", "error", "확인");
        result = false;
      } else if (this.accountId && !this.managerName) {
        await openDialog("관리자 이름을 입력해 주세요.", "error", "확인");
        result = false;
      }
      // 계정 변경 관련 검증
      else if (this.isAccountVerified) {
        // 새 아이디 입력 시 중복확인 여부 검증
        if (this.newManagerId.trim() && this.newManagerId.trim() !== this.managerId && !this.isManagerIdValid) {
          await openDialog("새 관리자 아이디 중복확인을 해 주세요.", "error", "확인");
          result = false;
        }
        // 비밀번호 일치 여부 검증
        else if (this.newPassword && this.newPassword !== this.confirmPassword) {
          await openDialog("비밀번호가 일치하지 않습니다.", "error", "확인");
          result = false;
        }
        // 비밀번호 길이 검증
        else if (this.newPassword && this.newPassword.length < 8) {
          await openDialog("비밀번호는 8자 이상이어야 합니다.", "error", "확인");
          result = false;
        }
      }
      return result;
    },

    initValues() {
      this.resellerName = "";
      this.ceoName = "";
      this.phoneNumber = "";
      this.businessNumber = "";
      this.originalBusinessNumber = "";
      this.managerName = "";
      this.managerDuty = "";
      this.managerPhoneNumber = "";
      this.managerId = "";
      this.logoImgUrl = "";
      this.logoPreviewUrl = "";
      this.isDetailLoaded = false;
      this.businessImgUrl = "";
      this.logoFileData = null;
      this.businessFileData = null;
      this.isTestCompany = false;
      this.accountId = "";

      // 계정 변경 관련 초기화
      this.verifyBusinessNumber = "";
      this.isAccountVerified = false;
      this.verifyMessage = "";
      this.newManagerId = "";
      this.newPassword = "";
      this.confirmPassword = "";
      this.isManagerIdValid = false;
      this.managerIdCheckMessage = "";

      let bFileInput;
      if (document.getElementById("businessFileInputM")) {
        bFileInput = document.getElementById("businessFileInputM").value;
        if (!bFileInput.length || bFileInput === "") {
          this.businessFileName = "";
        }
      }

      let lFileInput;
      if (document.getElementById("logoFileInputM")) {
        lFileInput = document.getElementById("logoFileInputM").value;
        if (!lFileInput.length || lFileInput === "") {
          this.logoFileName = "";
        }
      }
    },
  },
};
</script>

<style scoped>
.modalInputDiv {
  display: flex;
  align-items: center;
  margin-bottom: 0.5rem;
}

.modalInputDiv label {
  width: 30%;
  font-weight: 500;
}

.modalInputDiv input[type="text"],
.modalInputDiv input[type="password"] {
  width: 50%;
  border-radius: 5px;
  border: 1px solid #ccc;
  padding: 0.5rem;
  height: 35px;
}

.modalInputRight {
  display: flex;
  margin-left: 10px;
}

.modalBtnRight {
  margin-bottom: 0 !important;
  margin-right: 5px;
}

.imgPrev {
  max-width: 200px;
  max-height: 100px;
  margin-left: 30%;
}

.hide {
  display: none;
}

.businessNumberMsgM {
  font-size: 12px;
  margin-left: 30%;
}

.businessNumberMsgM.success {
  color: #28a745;
}

.businessNumberMsgM.fail {
  color: #dc3545;
}

.text-danger {
  color: #dc3545;
}

.account-change-section {
  background-color: #f8f9fa;
  padding: 1rem;
  border-radius: 8px;
  margin-top: 0.5rem;
}

.verifyMsg {
  font-size: 12px;
  margin-left: 30%;
}

.verifyMsg.success {
  color: #28a745;
}

.verifyMsg.fail {
  color: #dc3545;
}
</style>
